export var mapShade = function mapShade(_ref) {
  var colorHexCode = _ref.colorHexCode,
    colorImageUrl = _ref.colorImageUrl,
    productCode = _ref.productCode;
  var props = {
    productCode: productCode !== null && productCode !== void 0 ? productCode : ''
  };
  if (colorHexCode) {
    props.hexColors = colorHexCode.split(',');
  }
  if (colorImageUrl) {
    props.imageUrl = colorImageUrl;
  }
  return props;
};
//# sourceMappingURL=mapShade.js.map